import * as React from 'react'
import { AppService } from '@halo/services/app.service'
import { useService } from '@pushly/aqe/lib/hooks'
import { FeedsDataView } from '@pushly/aqe/lib/components/feeds/feeds-data-view'
import { Domain } from '@pushly/models/lib/structs'
import { DomainDto } from '@halo/dtos/domain.dto'
import { AppState } from '@halo/stores/app.state'
import { AbilityAction } from '@halo/enums/ability-action.enum'
import { asCaslSubject } from '@halo/stores/ability.state'
import { SubjectEntity } from '@halo/enums/ability-entity.enum'

interface IProps {
    domain: DomainDto
    appState: AppState
}

export const FeedsDataViewWrapper = (props: IProps) => {
    const appSvc = useService(AppService)

    const { appState } = props

    const canCreate = (): boolean => {
        return appState.abilityStore.can(
            AbilityAction.CREATE,
            asCaslSubject(SubjectEntity.FEED, { domainId: props.domain.id }),
        )
    }

    const canMutate = (): boolean => {
        return appState.abilityStore.can(
            AbilityAction.UPDATE,
            asCaslSubject(SubjectEntity.FEED, { domainId: props.domain.id }),
        )
    }

    return (
        <FeedsDataView
            hideRefresh={true}
            hideAutoRefreshOptions={true}
            domain={Domain.parseJsonObject(props.domain)}
            appSvc={appSvc}
            canCreate={canCreate}
            canMutate={canMutate}
            feedsPath={`/domains/${props.domain.id}/feeds`}
            userId={appState.currentUser.id}
        />
    )
}
